import * as JsCookie from "js-cookie"; // generated
export { DashboardCharts } from './dashboard/dashboard-charts';

// pass-through for Cookies API
export const Cookies = JsCookie.default;
